<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('banco-de-livros')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <b-link :href="material.LinkFree">
                <b-card no-body class="p-3 card_sistemacpv border-light">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </b-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'Banco de Livros',
      pageSubtitle: 'Ensino Infantil',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/atividades_dia_a_dia.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-infantil.png',
          bundle: 'Infantil',
          title: 'Atividades do dia a dia',
          segment: '0',
          discipline: 'Atividades do dia a dia',
          description: 'Infantil',
          toolTip: ' ',
          anoSerie: 'Série Bebês',
        },

        {
          linkReaOnly: '',
          LinkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/bichos_coisas_e_lugares.pdf',
          videoId: '',
          src: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/base-banco-livros-infantil.png',
          bundle: 'Infantil',
          title: 'Bichos Coisas e Lugares',
          segment: '0',
          discipline: 'Bichos Coisas e Lugares',
          description: 'Infantil',
          toolTip: ' ',
          anoSerie: 'Série Bebês',
        },

        {
          linkReaOnly: '',
          LinkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/comparar_as_coisas.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-infantil.png',
          bundle: 'Infantil',
          title: 'Comparar as Coisas',
          segment: '0',
          discipline: 'Comparar as Coisas',
          description: 'Infantil',
          toolTip: ' ',
          anoSerie: 'Série Bebês',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>